import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Card, CardBody, Col, Container } from "reactstrap";
import Swal from "sweetalert2";
import ButtonAddRole from "../../Components/Buttons/ButtonAddRole.js";
import DownloadReportCSVButton from "../../Components/Buttons/DownloadReportCSVButton.js";
import HeadersRole from "../../Components/Headers/HeadersRole.js";
import Loading from "../../Components/Loading";
import SearchBar from "../../Components/SearchBar/SearchBar.js";
import GATable from "../../Components/Tables/GATable/GATable.js";
import AddRoleModal from "../../Components/modals/GeneralModals/AddRoleModal.js";
import gaIcon from "../../assets/images/iconsRoles/GaIcon.svg";
import { DASHBOARD_USER_ROLES } from "../../constants";
import { addByNationalsId, getRolesForTables } from "../../slices/admin/thunk";
import { useCurrentUser } from "../../slices/auth/hooks.js";
import { downloadGAsReport } from "../../slices/national/thunk.js";
import DropdownActionsTable from "../../Components/Dropdown/DropdownActionsTable.js";
import CopyInviteLink from "../../Components/Buttons/CopyInviteLinkButton.js";
const DashboardNationalsGa = () => {
  const currentUser = useCurrentUser();
  const inputRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [loadingCreate, setLoadingCreate] = useState(false);

  const [modalAddGA, setModalAddGA] = useState(false);

  const dispatch = useDispatch();

  const [ga, setGa] = useState([]);
  const [totalGa, setTotalGa] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [activeTab, setActiveTab] = useState("1");

  const [currentPage, setCurrentPage] = useState(0);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timerId);
  }, [searchTerm]);

  const handleToggleModal = () => {
    setModalAddGA(!modalAddGA);
  };

  const fetchRolesNational = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        getRolesForTables({
          id: currentUser.id,
          userRole: "nationals",
          role: "ga",
          query: searchTerm,
          page: currentPage,
        })
      ).unwrap();
      setGa(response.data);
      setTotalGa(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      setSearchDone(true);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (debouncedSearchTerm === lastSearchTerm) {
      setSearchDone(true);
    } else {
      setSearchDone(false);
    }
    fetchRolesNational();
  }, [debouncedSearchTerm, dispatch, currentPage]);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const handleCreateGA = async (values) => {
    try {
      setLoadingCreate(true);
      const response = await dispatch(
        addByNationalsId({ id: currentUser.id, data: values })
      ).unwrap();
      if (!response.error) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "GA created successfully",
          timer: 2000,
          showConfirmButton: false,
        });
        setLoadingCreate(false);
        setModalAddGA(false);
        fetchRolesNational();
      } else {
        Swal.fire({
          title: "Error!",
          text: response.error || "An error occurred while adding GA",
          icon: "error",
          confirmButtonText: "OK",
        });
        setModalAddGA(true);
        setLoadingCreate(false);
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.message || "An error occurred while adding GA",
        icon: "error",
        confirmButtonText: "OK",
      });
      setModalAddGA(true);
      setLoadingCreate(false);
      console.log(error);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  return (
    <React.Fragment>
      {/* <Modal */}
      {modalAddGA && (
        <AddRoleModal
          open={modalAddGA}
          setOpen={setModalAddGA}
          roleToAdd={DASHBOARD_USER_ROLES.GA}
          onCreate={handleCreateGA}
          loading={loadingCreate}
        />
      )}
      <div className="page-content px-0 ">
        <Container fluid>
          <HeadersRole role={"GA"} icon={gaIcon} svg={true} />
          <Card className="mb-4 pb-3 ">
            <CardBody>
              <div className="col-12 d-flex justify-content-between mt-1 mb-4 align-items-center ">
                <div className="col-4 d-flex justify-content-end align-items-center">
                  <SearchBar
                    inputRef={inputRef}
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Filter by name or email"
                  />

                  <DropdownActionsTable
                    downloadMethod={downloadGAsReport}
                    params={{
                      nationalId: currentUser.id,
                    }}
                  />
                </div>

                <div className="col-4 d-flex justify-content-end align-items-center">

                  <CopyInviteLink role={DASHBOARD_USER_ROLES.GA} inviteCode={currentUser.inviteCode} />


                  <ButtonAddRole open={handleToggleModal} roleToAdd="GA" />


                  {/* <DownloadReportCSVButton
                    downloadMethod={downloadGAsReport}
                    params={{
                      nationalId: currentUser.id,
                    }}
                  /> */}
                </div>

                {/* // Button with three dots and the option " download csv" */}
              </div>

              <Col xl={12}>
                <div className="table-container  position-relative">
                  {loading && <Loading />}
                  <div className="live-preview">
                    <div className="table-responsive ">
                      <GATable
                        data={ga}
                        searchDone={searchDone}
                        searchParam={debouncedSearchTerm}
                        paginationProps={{
                          currentPage,
                          totalPages,
                          pageSize,
                          totalItems: totalGa,
                          onChangePage: handleChangePage,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </CardBody>
          </Card>
        </Container>
      </div>
      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardNationalsGa;
